export default __webpack_public_path__ + "static/media/website.c271a4c1.svg";